import React from "react";
import blankPhoto from "../../PicesForPages/blank.jpg";
import Kumar_Sista from "../../PicesForPages/Kumar_Sista_Team.png";
import Apeksha_Sista from "../../PicesForPages/Apeksha_Sista_Team.png";
// import Vishwas_Batheja from "../../PicesForPages/Vishwas_Batheja_Team.png";
import Vamsi_Krishna_Tummala from "../../PicesForPages/Vamsi_Krishna_Tummala_Team.png";
import Kousalya_Tummala from "../../PicesForPages/Kousalya_Tummala_Team.png";
import Sista_Kamesh from "../../PicesForPages/SistaKamesh_Team.png";
import Bhanu_Chennubhotla from "../../PicesForPages/Bhanu_Chennubhotla_Team.png";
import Maharshi_Patel from "../../PicesForPages/Maharshi_Patel.png";
import Raghuram_Mylavarapu from "../../PicesForPages/Raghuram_Mylavarapu.png";
import Sanjeeva_Pidugu from "../../PicesForPages/Sanjeeva_Pidugu_Team.png";
import Kalyan_Patibandla from "../../PicesForPages/Kalyan_Patibandla_Team.png";

import { Link } from "react-router-dom";

function YourTeamMembers() {
  const teamMembers = [
    {
      name: "Apeksha Sista",
      role: "Loan Originator",
      photo: Apeksha_Sista,
      link: "apeksha-sista",
      nmls: "2692605",
    },
    {
      name: "Kumar Sista",
      role: "Loan Originator",
      photo: Kumar_Sista,
      link: "kumar-sista",
      nmls: "2369551",
    },
    {
      name: "Vamsi Tummala",
      role: "Loan Originator",
      photo: Vamsi_Krishna_Tummala,
      link: "vamsi-tummala",
      nmls: "2587554",
    },
    {
      name: "Kousalya Tummala",
      role: "Loan Originator",
      photo: Kousalya_Tummala,
      link: "kousalya-tummala",
      nmls: "2587557",
    },
    {
      name: "Vai Sista",
      role: "Loan Originator",
      photo: Sista_Kamesh,
      link: "vai-sista",
      nmls: "2719500",
    },
    {
      name: "Bhanu Chennubhotla",
      role: "Loan Originator",
      photo: Bhanu_Chennubhotla,
      link: "bhanu-chennubhotla",
      nmls: "2497400",
    },
    {
      name: "Maharshi Patel",
      role: "Loan Originator",
      photo: Maharshi_Patel,
      link: "maharshi-patel",
      nmls: "2781812",
    },
    {
      name: "Kiran G",
      role: "Loan Originator",
      photo: blankPhoto,
      link: "kiran-g",
      nmls: "2525597",
    },
    {
      name: "Raghuram Mylavarapu",
      role: "Loan Originator",
      photo: Raghuram_Mylavarapu,
      link: "raghuram-mylavarapu",
      nmls: "2620091",
    },
    {
      name: "Sanjeeva Pidugu",
      role: "Loan Originator",
      photo: Sanjeeva_Pidugu,
      link: "sanjeeva-pidugu",
      nmls: "2776226",
    },
    {
      name: "Kalyan Patibandla",
      role: "Loan Originator",
      photo: Kalyan_Patibandla,
      link: "kalyan-patibandla",
      nmls: "2787855",
    },
    {
      name: "Coming Soon",
      role: "---- ---------",
      photo: blankPhoto,
      link: "",
      nmls: "-------",
    },
  ];

  return (
    <div className="teamBoxParent">
      <div className="teamBox">
        <span className="teamHeading">Meet Our Family</span>
        <span className="teamContent">
          Our team at <span className="logoBoldColor">The Mortgageist</span> is
          fast, friendly, experienced, and here to help you every step of the
          process!
        </span>
        <div className="teamListBoxParent">
          {teamMembers.map((member, index) => (
            <Link
              to={member.link !== "#" ? `/our-family/${member.link}` : "#"}
              className="teamListBox"
              key={index}
            >
              <span className="teamListSpanImage">
                <img
                  fetchPriority="high"
                  loading="eager"
                  src={member.photo}
                  alt={member.name}
                />
              </span>
              <span className="teamListNameOfficer">
                <span className="teamListOfficerRole">{member.role}</span>
                <span className="teamListName">{member.name}</span>
                <hr className="teamListHR" />
                <span className="teamListOfficerNMLSViewProfile">
                  <span className="teamListOfficerNMLS">
                    NMLS#: {member.nmls}
                  </span>
                  <span className="teamListOfficerViewProfile">
                    VIEW PROFILE <i className="ri-arrow-right-circle-line"></i>
                  </span>
                </span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default YourTeamMembers;
